import React from 'react';
import { GoToContext } from '../GoToContext';

function useGoTo() {
  const context = React.useContext(GoToContext);

  if (!context) {
    throw new Error(`useGoTo must be used within a GoToProvider`);
  }

  const {
    mapRef,
    goTo,
    fitToBounds,
    registerMapCapture,
    captureMapScreenshot,
    registerMapLegend,
    exportLegend,
  } = context;

  return {
    mapRef,
    goTo,
    fitToBounds,
    registerMapCapture,
    captureMapScreenshot,
    registerMapLegend,
    exportLegend,
  };
}

export { useGoTo };
